import * as yup from "yup";

export type TaskCreateType = "individual" | "bulk";
export type BulkScope = "all" | "selected";

export interface TaskCreateFormValues {
  type: TaskCreateType;
  bulkScope: BulkScope;
  surveyid: string;
  count: string;
  booth: any;
  booths: any[];
}

const requiredString = yup.string().trim().required("This field is required");

export const taskCreateSchema = yup.object({
  type: yup.mixed<TaskCreateType>().oneOf(["individual", "bulk"]).required(),
  bulkScope: yup.mixed<BulkScope>().oneOf(["all", "selected"]).required(),

  surveyid: requiredString,

  count: yup
    .string()
    .required("Please enter a valid number of interviews")
    .test("is-positive-int", "Please enter a valid number of interviews", (value) => {
      const n = parseInt(String(value || ""), 10);
      return Number.isFinite(n) && n > 0;
    }),

  booth: yup.mixed().when("type", {
    is: "individual",
    then: (s) => s.test("booth-required", "Please select a booth", (v) => Boolean(v && v?.['value'] as any)),
    otherwise: (s) => s.notRequired(),
  }),

  booths: yup.array().when(["type", "bulkScope"], {
    is: (type: TaskCreateType, bulkScope: BulkScope) => type === "bulk" && bulkScope === "selected",
    then: (s) => s.min(1, "Please select at least one booth"),
    otherwise: (s) => s.notRequired(),
  }),
});


